/* campaign-sale-price — keep our "was / now" campaign figures correct per
 * variant and in the shopper's currency. The spans are normal .money elements
 * with data-currency-original (base cents), so the store's currency app converts
 * them. Server render is correct for the first variant; we only re-write on
 * variant change, then re-run the converter. Self-contained — does not touch the
 * theme's (hidden) native price elements.
 */
(function () {
  'use strict';
  if (window.__mpCampaignSalePrice) return; // load-once guard (rendered twice on the page)
  window.__mpCampaignSalePrice = true;

  function variantId(scope) {
    var input = scope.querySelector('[data-product-form] [name="id"]');
    return input ? input.value : null;
  }

  function reconvert(root) {
    var sc = root.getAttribute('data-shop-currency');
    if (sc && window.Currency && typeof window.Currency.convertAll === 'function') {
      var t =
        window.Currency.currentCurrency ||
        (window.Currency.cookie && window.Currency.cookie.read && window.Currency.cookie.read('currency')) ||
        sc;
      try { window.Currency.convertAll(sc, t); } catch (e) {}
    }
  }

  function setMoney(el, entry, sc) {
    if (!el || !entry) return;
    el.classList.add('money');
    el.setAttribute('data-currency', sc || '');
    el.setAttribute('data-currency-original', entry.c);
    el.textContent = entry.m;
  }

  function update(root) {
    var map;
    try { map = JSON.parse(root.getAttribute('data-cp-prices') || '{}'); }
    catch (e) { return; }
    var scope = root.closest('[data-product-wrapper]') || document;
    var id = variantId(scope);
    var entry = id && map[id];
    if (!entry) return;
    var sc = root.getAttribute('data-shop-currency');
    setMoney(root.querySelector('[data-cp-now]'), entry, sc);
    setTimeout(function () { reconvert(root); }, 50);
  }

  function updateAll() {
    var nodes = document.querySelectorAll('[data-campaign-price]');
    for (var i = 0; i < nodes.length; i++) update(nodes[i]);
  }

  function init() {
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'id') setTimeout(updateAll, 40);
    });
    var vs = document.querySelector('[data-variant-selection]');
    if (vs) vs.addEventListener('variant-change', function () { setTimeout(updateAll, 40); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', updateAll);
})();
